module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ImgIntroduction"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "353px"
    }
  }, [(_vm.have) ? _c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "ImgIntroduction"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.content) + "\n\t\t")]) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('van-loading', {
    attrs: {
      "color": "black"
    }
  })], 1)]), _vm._v(" "), (_vm.xianshilist == '2') ? _c('div', {
    staticClass: "zizhilist"
  }, [_c('div', {
    staticClass: "lianghezi"
  }, [_c('div', {
    staticClass: "xinxi",
    on: {
      "click": _vm.tiaozhuangxin
    }
  }, [_c('p', [_vm._v("公司信息")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jishuzhichi"
  }, [_c('p', [_vm._v("腾慧云直播提供技术支持")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tiaoguanw"
  }, [_c('a', {
    attrs: {
      "href": "https://www.tenghuiwangxiao.cn/"
    }
  }, [_vm._v("www.tenghuiwangxiao.cn")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-552de6b6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/ImgText.vue
// module id = 243
// module chunks = 0